/* src/app/modules/shared/components/member-certificates/member-certificates.component.scss */
mat-list-item {
  margin-bottom: 4px;
}
/*# sourceMappingURL=member-certificates.component.css.map */
